import { CommonGet, CommonPost } from "../../../utils/CommonFetch";


export default {
    getCustomerByID,
    getBiometrics,
    getCustomerBalanceByID,
    getCollectionCountByType,
    getFactoryItemsByCustomer,
    getLastCollectionDetailsByCustomerID,
    GetLastAdvancedDetailsByCustomerID,
    GetLastPaymentDetailsByCustomerID
}

async function getCustomerByID(customerID) {
    
    var response = await CommonGet('/api/Customer/GetCustomerByID', 'customerID=' + parseInt(customerID));
    return response.data;
}


async function getBiometrics(cusId,typeId){
    let filtermodel = {
        customerID: parseInt(cusId),
        customerBiometricDataTypeID: typeId,
        
    }
    const response = await CommonPost('/api/CustomerBiometrics/GetDefaultCustomerBiometricById', null, filtermodel);
    
    return response.data;
}

async function getCustomerBalanceByID(customerID) {
    
    var response = await CommonGet('/api/CustomerBalance/GetCustomerBalanceByID', 'customerID=' + parseInt(customerID));
    return response.data;
}

async function getCollectionCountByType(id,typeId){
    let filtermodel = {
        customerID: parseInt(id),
        filterTypeID: typeId,
        
    }
    const response = await CommonPost('/api/ProductCollection/GetProductCollectionCountByType', null, filtermodel);
    
    return response.data;
}

async function getFactoryItemsByCustomer(customerID) {
    
    var response = await CommonGet('/api/FactoryItem/GetLatestFactoryItemByCustomerID', 'customerID=' + parseInt(customerID));
    return response;
}

async function getLastCollectionDetailsByCustomerID(customerID) {
    
    var response = await CommonGet('/api/ProductCollection/GetLastCollectionDetailsByCustomerID', 'customerID=' + parseInt(customerID));
    return response.data;
}

async function GetLastAdvancedDetailsByCustomerID(customerID) {
    
    var response = await CommonGet('/api/AdvancedDetails/GetLastAdvancedDetailsByCustomerID', 'customerID=' + parseInt(customerID));
    return response.data;
}

async function GetLastPaymentDetailsByCustomerID(customerID) {
    
    var response = await CommonGet('/api/PaymentDetails/GetLastPaymentDetailsByCustomerID', 'customerID=' + parseInt(customerID));
    return response.data;
}